import uuid from 'react-uuid'

export const saveContact = async (info: any) => {}
